var _title, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcSend = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "14px",
    viewBox: "0 0 17 14",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "ic_chevron_right copy")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "bvcbnvcb",
    x: 0,
    y: 0,
    width: 1170,
    height: 382,
    rx: 4
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.0%",
    y: "-2.0%",
    width: "102.0%",
    height: "106.0%",
    filterUnits: "objectBoundingBox",
    id: "aaaaaaass"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "hgfhgfhgfhf",
    x: 0,
    y: 0,
    width: 1170,
    height: 68
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "bjokokok",
    points: "1.5075 15.75 17.25 9 1.5075 2.25 1.5 7.5 12.75 9 1.5 10.5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "bjokokok2",
    x: 0,
    y: 0,
    width: 37.5,
    height: 37.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "oooooookkkrr",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sssfdsfsdafsafs",
    transform: "translate(-895.000000, -213.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 1440,
    height: 1024
  }), /*#__PURE__*/React.createElement("rect", {
    id: "bugagag",
    stroke: "#DFE2E5",
    fill: "#F7F8FA",
    x: -0.5,
    y: 123.5,
    width: 1441,
    height: 901
  }), /*#__PURE__*/React.createElement("g", {
    id: "table444send",
    transform: "translate(250.000000, 144.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "massso44",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bvcbnvcb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "massssssk"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#aaaaaaass)",
    xlinkHref: "#bvcbnvcb"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#DFE2E5",
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#bvcbnvcb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "rowenko",
    mask: "url(#massso44)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ihaterwreitrerq",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hgfhgfhgfhf"
  })), /*#__PURE__*/React.createElement("use", {
    id: "massssssk",
    stroke: "none",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#hgfhgfhgfhf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "grpupadsa-10",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    mask: "url(#ihaterwreitrerq)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(644.000000, 25.000000)",
    id: "ihaterwreit"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "gjjiwqewq",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bjokokok"
  })), /*#__PURE__*/React.createElement("g", {
    id: "massssssk"
  }), /*#__PURE__*/React.createElement("g", {
    id: "grpupadsa",
    mask: "url(#gjjiwqewq)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.750000, -9.750000)",
    id: "color4ekqeq"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bjokokok2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "blockada2d",
    fill: "#1890FF",
    xlinkHref: "#bjokokok2"
  }))))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcSend, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-send.662093ac.svg";
export { ForwardRef as ReactComponent };